import { ValidationValue, ValidationValueMessage } from 'react-hook-form';

export const getValidationValue = <T extends ValidationValue>(
  rule: T | ValidationValueMessage<T> | undefined
): T | undefined => {
  if (
    typeof rule === 'string' ||
    typeof rule === 'boolean' ||
    typeof rule === 'number' ||
    rule instanceof RegExp
  ) {
    return rule;
  }

  if (rule && typeof rule === 'object' && 'value' in rule) {
    return rule.value;
  }

  return undefined;
};
